import {
	rosCommunicationQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';

export const rosCommunicationQueryKey = ['credits-ros'];

export interface RosCommunicationQueryProps {
	isEnabled?: boolean;
	retry?: number;
	refetchOnWindowFocus?: boolean;
}

export const useRosCommunicationQuery = ({
	isEnabled,
	retry,
	refetchOnWindowFocus,
}: RosCommunicationQueryProps = {}) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: rosCommunicationQueryKey,
		queryFn: () => rosCommunicationQuery(axiosInstance),
		enabled: isEnabled,
		retry,
		refetchOnWindowFocus,
	});

	return query;
};
